<section class="dashboard-management">
  <div class="dashboard-management__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="dashboard-management__header__actions">
      <!-- `*appHasPermission` além do `[hidden]`: são coisas diferentes. O `[hidden]`
           esconde mas MONTA o componente, e ele busca a lista de empresas no `ngOnInit` —
           quem não pode listar empresas (o parceiro, card 2901: "o seletor de escopo de
           empresa não aparece nesta fase") levava 403 e o toast de sem permissão só por
           abrir a Dashboard. Não montar é o que resolve. -->
      <app-select-company
        *appHasPermission="companyListPermission"
        [hidden]="isCompanyIdUser"
        [allowEmptyPlaceholderSelect]="true"
        [multiple]="true"
        [showLabel]="false"
        [selectionScope]="'page-filter'"
        [persistLocalSelectionToUrl]="true"
        [selectedCompanyValues]="selectedCompanyIds"
        [showCompanyIcon]="true"
        (sendSelectedOptionMultiple)="onDashboardManagementCompanySelectedMultiple($event)"
        [placeholder]="tk.General.AllCompanies | t"
        class="company-select company-select--header">
      </app-select-company>
      @if (keyIndicatorsDashboard?.lastSuccessfulUpdateAtGmt; as updatedAt) {
        <span class="dashboard-management__updated">
          <span></span>
          Atualizado {{ formatHeaderUpdateTime(updatedAt) }}
        </span>
      }
      <app-button
        icon="sync"
        theme="white"
        size="small"
        class="dashboard-header-refresh"
        title="Atualizar dashboard"
        [noMargin]="true"
        (sendClick)="refreshDashboardData()">
      </app-button>
      @if (!isEditingIndicators) {
        <app-button
          icon="sliders-h"
          theme="white"
          size="small"
          label="Personalizar"
          class="dashboard-header-personalize"
          title="Personalizar indicadores fixos"
          [noMargin]="true"
          (sendClick)="startEditingIndicators()">
        </app-button>
      } @else {
        <div class="indicators-edit-toolbar">
          <span
            class="indicators-edit-toolbar__status"
            [class.indicators-edit-toolbar__status--limit]="fixedIndicatorIds.length >= 8"
            [class.indicators-edit-toolbar__status--warning]="!canSaveFixedIndicators">
            <i class="pi pi-th-large"></i>
            {{ fixedIndicatorsLimitLabel }} · mín. 4
          </span>
          <span class="indicators-edit-toolbar__divider"></span>
          <app-button
            theme="white"
            size="small"
            icon="sync"
            label="Restaurar padrão"
            class="dashboard-edit-reset"
            title="Restaurar indicadores padrão"
            [noMargin]="true"
            (sendClick)="resetFixedIndicators()">
          </app-button>
          <app-button
            icon="check"
            theme="highlight"
            size="small"
            label="Concluir"
            class="dashboard-edit-finish"
            title="Concluir personalização"
            [noMargin]="true"
            (sendClick)="finishEditingIndicators()">
          </app-button>
        </div>
      }
      <p-popover #indicatorPicker styleClass="indicator-picker-popover">
        <div class="indicator-picker">
          <div class="indicator-picker__title">{{ indicatorPickerTitle }}</div>
          <label class="indicator-picker__search" aria-label="Buscar indicador disponível">
            <i class="pi pi-search"></i>
            <input
              type="search"
              placeholder="Buscar indicador"
              [value]="fixedIndicatorSearchTerm"
              (input)="updateFixedIndicatorSearchTerm($event)" />
            @if (fixedIndicatorSearchTerm) {
              <button
                type="button"
                aria-label="Limpar busca"
                (click)="clearFixedIndicatorSearchTerm()">
                <i class="pi pi-times"></i>
              </button>
            }
          </label>
          <div class="indicator-picker__list">
            @for (group of availableFixedIndicatorGroups; track group.label) {
              <div class="indicator-picker__group-title">{{ group.label }}</div>
              <div class="indicator-picker__chips">
                @for (option of group.options; track option.id) {
                  <button
                    type="button"
                    class="indicator-picker__chip"
                    (click)="selectIndicatorFromPicker(option.id)">
                    <i class="pi pi-plus"></i>
                    <span>{{ option.label }}</span>
                  </button>
                }
              </div>
            } @empty {
              <div class="indicator-picker__empty">
                {{
                  fixedIndicatorSearchTerm
                    ? 'Nenhum indicador encontrado.'
                    : 'Todos os indicadores já estão fixos.'
                }}
              </div>
            }
          </div>
        </div>
      </p-popover>
    </div>
  </div>

  @if (isEditingIndicators) {
    <div class="dashboard-management__personalize-banner">
      <i class="pi pi-th-large"></i>
      <span class="dashboard-management__personalize-banner__title">Modo de personalização</span>
      <span class="dashboard-management__personalize-banner__hint">
        Arraste, troque ou remova indicadores · mín. 4 · máx. 8
      </span>
    </div>
  }

  <div
    class="grid-kpi"
    [class.grid-kpi--editing]="isEditingIndicators"
    cdkDropList
    cdkDropListOrientation="mixed"
    [cdkDropListDisabled]="!isEditingIndicators"
    [cdkDropListData]="fixedIndicatorIds"
    (cdkDropListDropped)="dropFixedIndicator($event)">
    @for (indicatorId of fixedIndicatorIds; track indicatorId; let index = $index) {
      <div
        class="card"
        [class.card--editing]="isEditingIndicators"
        cdkDrag
        [cdkDragData]="indicatorId"
        [cdkDragDisabled]="!isEditingIndicators">
        @if (isEditingIndicators) {
          <div class="card__edit-overlay">
            <button
              type="button"
              class="card__swap"
              title="Trocar indicador desta posição"
              (click)="openSwapIndicatorPicker($event, index)">
              <span>Trocar</span>
              <i class="pi pi-angle-down"></i>
            </button>
            <button
              type="button"
              class="card__remove"
              [disabled]="fixedIndicatorIds.length <= 4"
              [title]="
                fixedIndicatorIds.length <= 4 ? 'Mínimo de 4 indicadores' : 'Remover indicador'
              "
              (click)="removeFixedIndicator(indicatorId)">
              <i class="pi pi-times"></i>
            </button>
          </div>
        }
        @switch (indicatorId) {
          @case ('cdi') {
            <ng-container *ngIf="isLoadingCdi; else cdiContent">
              <ng-container *ngTemplateOutlet="kpiSkeleton"></ng-container>
            </ng-container>
            <ng-template #cdiContent>
              <div class="kpi-header">
                <div>
                  <div class="kpi-title">{{ tk.General.CDI | t }}</div>
                </div>
                <div class="kpi-icon-box bg-icon-dark">
                  <i class="pi pi-chart-line"></i>
                </div>
              </div>
              <div class="kpi-value-row">
                <span class="kpi-value">{{
                  cdiDailyAnnualizedCurrent?.annualized || 0 | vaultFormatPercent: 2
                }}</span>
              </div>
              <div class="kpi-meta">
                <div
                  class="badge"
                  [ngClass]="{
                    'badge-success': (cdiDailyAnnualizedCurrent?.value || 0) > 0,
                    'badge-danger': (cdiDailyAnnualizedCurrent?.value || 0) < 0,
                    'badge-neutral': (cdiDailyAnnualizedCurrent?.value || 0) === 0,
                  }">
                  {{ tk.General.Month | t }}
                  {{ cdiDailyAnnualizedCurrent?.value || 0 | vaultFormatPercent: 2 }}
                </div>
                <span
                  >{{ tk.General.Updated | t }}
                  {{ cdiDailyAnnualizedCurrent?.date ?? null | vaultDate }}</span
                >
              </div>
            </ng-template>
          }
          @case ('ipca') {
            <ng-container *ngIf="isLoadingIpca; else ipcaContent">
              <ng-container *ngTemplateOutlet="kpiSkeleton"></ng-container>
            </ng-container>
            <ng-template #ipcaContent>
              <div class="kpi-header">
                <div>
                  <div class="kpi-title">
                    {{ tk.General.IPCA | t }} ({{ tk.General.Month | t }})
                  </div>
                </div>
                <div class="kpi-icon-box bg-icon-purple">
                  <i class="pi pi-percentage"></i>
                </div>
              </div>
              <div class="kpi-value-row">
                <span class="kpi-value">{{
                  ipcaMonthCurrent?.value || 0 | vaultFormatPercent: 2
                }}</span>
              </div>
              <div class="kpi-meta">
                <div class="kpi-meta-badges">
                  <div class="badge badge-success">
                    12M
                    {{ ipcaMonthCurrent?.accumulatedLast12Months || 0 | vaultFormatPercent: 2 }}
                  </div>
                  <div class="badge badge-success">
                    {{ tk.General.Year | t }}
                    {{ ipcaMonthCurrent?.accumulatedYear || 0 | vaultFormatPercent: 2 }}
                  </div>
                </div>
                <span
                  >{{ tk.General.Updated | t }}
                  {{ ipcaMonthCurrent?.date ?? null | vaultDate }}</span
                >
              </div>
            </ng-template>
          }
          @case ('sofr') {
            <ng-container *ngIf="isLoadingSofr; else sofrContent">
              <ng-container *ngTemplateOutlet="kpiSkeleton"></ng-container>
            </ng-container>
            <ng-template #sofrContent>
              <div class="kpi-header">
                <div>
                  <div class="kpi-title">{{ tk.General.SOFR | t }}</div>
                </div>
                <div class="kpi-icon-box bg-icon-green">
                  <i class="pi pi-globe"></i>
                </div>
              </div>
              <div class="kpi-value-row">
                <span class="kpi-value">{{ sofrCurrent?.value || 0 | vaultFormatPercent: 2 }}</span>
              </div>
              <div class="kpi-meta">
                <div class="badge badge-danger" style="font-style: italic">Overnight Financing</div>
                <span
                  >{{ tk.General.Updated | t }} {{ sofrCurrent?.date ?? null | vaultDate }}</span
                >
              </div>
            </ng-template>
          }
          @case ('currency:USD') {
            <ng-container *ngTemplateOutlet="currencyCard; context: { code: 'USD', index: index }">
            </ng-container>
          }
          @case ('currency:EUR') {
            <ng-container *ngTemplateOutlet="currencyCard; context: { code: 'EUR', index: index }">
            </ng-container>
          }
          @case ('currency:CNY') {
            <ng-container *ngTemplateOutlet="currencyCard; context: { code: 'CNY', index: index }">
            </ng-container>
          }
          @case ('ptax:USD') {
            <ng-container
              *ngTemplateOutlet="
                ptaxCard;
                context: { code: 'USD', index: index, quoteType: 'sale' }
              ">
            </ng-container>
          }
          @case ('ptax-buy:USD') {
            <ng-container
              *ngTemplateOutlet="
                ptaxCard;
                context: { code: 'USD', index: index, quoteType: 'purchase' }
              ">
            </ng-container>
          }
          @case ('ptax:EUR') {
            <ng-container
              *ngTemplateOutlet="
                ptaxCard;
                context: { code: 'EUR', index: index, quoteType: 'sale' }
              ">
            </ng-container>
          }
          @case ('ptax-buy:EUR') {
            <ng-container
              *ngTemplateOutlet="
                ptaxCard;
                context: { code: 'EUR', index: index, quoteType: 'purchase' }
              ">
            </ng-container>
          }
          @case ('implicit-ipca') {
            @if (isLoadingImplicitIpcaCurve) {
              <ng-container *ngTemplateOutlet="kpiSkeleton"></ng-container>
            } @else if (getLatestImplicitIpcaPoint(); as implicitIpcaPoint) {
              <div class="kpi-header">
                <div>
                  <div class="kpi-title">IPCA Implícito</div>
                </div>
                <div class="kpi-icon-box bg-icon-green">
                  <i class="pi pi-chart-line"></i>
                </div>
              </div>
              <div class="kpi-value-row">
                <span class="kpi-value">
                  {{ implicitIpcaPoint.implicitIpcaRate || 0 | vaultFormatPercent: 2 }}
                </span>
              </div>
              <div class="kpi-meta">
                <!-- Deixou de ser DI1 × DAP em 11/08/2026: a curva vem pronta do provedor. -->
                <div class="badge badge-neutral">Curva CMA</div>
                <span>Vencimento {{ implicitIpcaPoint.maturityDate | vaultDate }}</span>
              </div>
            } @else {
              <ng-container *ngTemplateOutlet="kpiSkeleton"></ng-container>
            }
          }
          @default {
            @if (getKeyIndicatorByFixedId(indicatorId); as indicator) {
              <div class="kpi-header">
                <div>
                  <div class="kpi-title">{{ getKeyIndicatorDisplayName(indicator) }}</div>
                </div>
                <div class="kpi-icon-box" [ngClass]="getKeyIndicatorIconBoxClass(indicator)">
                  <i [class]="getKeyIndicatorIconClass(indicator)"></i>
                </div>
              </div>
              <div class="kpi-value-row">
                <span class="kpi-value">{{ indicator.formattedValue || '-' }}</span>
              </div>
              <div class="kpi-meta">
                <div class="badge" [ngClass]="getKeyIndicatorBadgeClass(indicator)">
                  {{ indicator.period || 'Atual' }}
                </div>
                @if (getKeyIndicatorPrimaryMetadata(indicator); as metadata) {
                  <span>{{ metadata.label }}: {{ metadata.value }}</span>
                }
                <span>{{ indicator.source }}</span>
              </div>
            } @else {
              <ng-container *ngTemplateOutlet="kpiSkeleton"></ng-container>
            }
          }
        }
      </div>
    }
    @if (isEditingIndicators && fixedIndicatorIds.length < 8) {
      <button
        type="button"
        class="card card--add"
        title="Adicionar indicador"
        (click)="openAddIndicatorPicker($event)">
        <span class="card--add__icon"><i class="pi pi-plus"></i></span>
        <span class="card--add__label">Adicionar indicador</span>
      </button>
    }
  </div>

  <ng-template #kpiSkeleton>
    <div class="kpi-skeleton">
      <div class="kpi-skeleton-header">
        <div class="kpi-skeleton-title"></div>
        <div class="kpi-skeleton-icon"></div>
      </div>
      <div class="kpi-skeleton-value"></div>
      <div class="kpi-skeleton-meta">
        <div class="kpi-skeleton-badge"></div>
        <div class="kpi-skeleton-date"></div>
      </div>
    </div>
  </ng-template>

  <ng-template #currencyCard let-code="code" let-index="index">
    @if (isLoadingCurrencies) {
      <ng-container *ngTemplateOutlet="kpiSkeleton"></ng-container>
    } @else if (getCurrencyByCode(code); as currency) {
      <div class="kpi-header">
        <div>
          <div class="kpi-title">
            {{ currency?.currency
            }}<span class="font-weight-normal">({{ tk.General.Actual | t }})</span>
          </div>
        </div>
        <div class="kpi-icon-box" [ngClass]="getCurrencyIconClass(code, index)">
          <ng-container *ngIf="isYuanCurrency(code); else primeCurrencyIcon">
            <fa-icon [icon]="faCny"></fa-icon>
          </ng-container>
          <ng-template #primeCurrencyIcon>
            <i [ngClass]="getCurrencyIcon(code)"></i>
          </ng-template>
        </div>
      </div>
      <div class="kpi-value-row">
        <span class="kpi-value">
          {{ (currency?.currentQuote || 0 | vaultFormatCurrency: 4).slice(0, -2) }}
          <span class="kpi-decimal">
            {{ (currency?.currentQuote || 0 | vaultFormatCurrency: 4).slice(-2) }}
          </span>
        </span>
      </div>
      <div class="kpi-meta">
        <div class="kpi-meta-badges">
          <div
            class="badge"
            [ngClass]="{
              'badge-success': (currency?.dailyVariation || 0) > 0,
              'badge-danger': (currency?.dailyVariation || 0) < 0,
              'badge-neutral': (currency?.dailyVariation || 0) === 0,
            }">
            {{ tk.General.Day | t }}
            {{ currency?.dailyVariation || 0 | vaultFormatPercent: 2 }}
          </div>
          <div
            class="badge"
            [ngClass]="{
              'badge-success': (currency?.yearlyVariation || 0) > 0,
              'badge-danger': (currency?.yearlyVariation || 0) < 0,
              'badge-neutral': (currency?.yearlyVariation || 0) === 0,
            }">
            {{ tk.General.Year | t }}
            {{ currency?.yearlyVariation || 0 | vaultFormatPercent: 2 }}
          </div>
        </div>
        @if (currency?.collectedAt) {
          <span>Coletado em {{ currency.collectedAt | vaultDateTime }}</span>
        }
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="kpiSkeleton"></ng-container>
    }
  </ng-template>

  <ng-template #ptaxCard let-code="code" let-index="index" let-quoteType="quoteType">
    @if (isLoadingPtaxCurve) {
      <ng-container *ngTemplateOutlet="kpiSkeleton"></ng-container>
    } @else if (getLatestPtaxPoint(code); as ptaxPoint) {
      <div class="kpi-header">
        <div>
          <div class="kpi-title">PTAX {{ code }}</div>
        </div>
        <div class="kpi-icon-box" [ngClass]="getCurrencyIconClass(code, index)">
          <i [ngClass]="getCurrencyIcon(code)"></i>
        </div>
      </div>
      <div class="kpi-value-row">
        <span class="kpi-value">
          {{ (getPtaxQuoteValue(ptaxPoint, quoteType) || 0 | vaultFormatCurrency: 4).slice(0, -2) }}
          <span class="kpi-decimal">
            {{ (getPtaxQuoteValue(ptaxPoint, quoteType) || 0 | vaultFormatCurrency: 4).slice(-2) }}
          </span>
        </span>
      </div>
      <div class="kpi-meta">
        <div class="badge badge-neutral">{{ getPtaxQuoteTypeLabel(quoteType) }} PTAX</div>
        <span>Último disponível {{ ptaxPoint.quoteDate | vaultDate }}</span>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="kpiSkeleton"></ng-container>
    }
  </ng-template>
  <div class="dashboard-management__body">
    <div class="dashboard-management__main">
      <!-- Cenário de Economia: NÃO renderiza no escopo "Todas empresas" — exige empresa
           explicitamente selecionada (regra documentada em shouldShowDashboardEconomyScenario). -->
      @if (shouldShowDashboardEconomyScenario) {
        <app-economy-scenario-cards
          [selectedCompanyIds]="selectedCompanyIds"></app-economy-scenario-cards>
        <app-debt-performance-chart
          [selectedCompanyIds]="selectedCompanyIds"></app-debt-performance-chart>
      }
      <section class="dashboard-management__panel">
        <app-di1-curve-chart [selectedCompanyId]="selectedCompanyId"></app-di1-curve-chart>
      </section>
      <section class="dashboard-management__panel">
        <app-ptax-curve-chart></app-ptax-curve-chart>
      </section>
      <app-card-info *ngIf="showDerivativeBarChart">
        <div class="card-info">
          <div class="card-info__item card-info__item--100">
            <div class="card-info__item__title card-info__item__title--highlight">
              {{ tk.General.DerivativesIndex | t }}
            </div>
            <div class="card-info__item__chart">
              <canvas id="derivative-bar-chart"></canvas>
            </div>
          </div>
        </div>
      </app-card-info>
    </div>

    <aside class="dashboard-management__aside">
      <section class="dashboard-management__dashboard calendar-panel">
        <div class="calendar-panel__header">
          <div class="calendar-panel__title">
            {{ tk.General.ExpirationCalendars | t }}
          </div>
        </div>
        <div class="calendar-panel__meta">
          <span class="calendar-panel__count">
            <i class="pi pi-calendar"></i>
            {{ calendarEventsCount }} vencimentos
          </span>
          <span class="calendar-panel__hint">
            <i class="pi pi-info-circle"></i>
            Clique numa data destacada para ver os eventos
          </span>
        </div>
        <div class="calendar-wrapper">
          <p-datePicker
            class="responsive-calendar"
            [(ngModel)]="currentDate"
            [inline]="true"
            [showOtherMonths]="false"
            [selectOtherMonths]="false"
            [numberOfMonths]="2"
            [view]="'date'"
            (onSelect)="onSelectDate($event)"
            (onMonthChange)="onMonthChange($event)">
            <ng-template pTemplate="date" let-date>
              <span
                [ngClass]="{
                  'event-day': isHighlighted(date),
                  'selected-day': isSelected(date),
                }">
                {{ date.day }}
              </span>
            </ng-template>
          </p-datePicker>
        </div>
        <div class="calendar-panel__upcoming">
          <div class="calendar-panel__upcoming-title">PRÓXIMOS VENCIMENTOS</div>
          @for (item of upcomingCalendarEvents; track item.date + '-' + item.index) {
            <button
              type="button"
              class="calendar-panel__event"
              [attr.aria-describedby]="'calendar-event-detail-' + item.date + '-' + item.index"
              (click)="onSelectDate(item.dateObject)">
              <span class="calendar-panel__event-date">
                {{ item.dateObject | date: 'dd/MM' }}
              </span>
              <span class="calendar-panel__event-name">
                {{ item.title }}
              </span>
              <span class="calendar-panel__event-value">
                {{ item.currencyCode }}
                {{ item.value | vaultFormatCurrency: 2 }}
              </span>
              <span
                class="calendar-panel__event-detail"
                [id]="'calendar-event-detail-' + item.date + '-' + item.index"
                role="tooltip">
                <span class="calendar-panel__event-detail-header">
                  <span class="calendar-panel__event-detail-icon">
                    <i class="pi pi-calendar-clock"></i>
                  </span>
                  <span class="calendar-panel__event-detail-heading">
                    <span class="calendar-panel__event-detail-title">Detalhes do vencimento</span>
                    <span class="calendar-panel__event-detail-subtitle">
                      {{ item.title }}
                    </span>
                  </span>
                </span>
                <span class="calendar-panel__event-detail-body">
                  @for (row of item.detailRows; track row.label) {
                    <span class="calendar-panel__event-detail-row">
                      <span class="calendar-panel__event-detail-label">
                        {{ row.label }}
                      </span>
                      <span class="calendar-panel__event-detail-value">
                        {{ row.value }}
                      </span>
                    </span>
                  }
                </span>
              </span>
            </button>
          } @empty {
            <div class="calendar-panel__empty">Sem vencimentos nos próximos meses</div>
          }
        </div>
        <a [routerLink]="['/dashboard/consolidated-due-date']" class="view-all-link">
          <span class="pi pi-external-link"></span>
          <span>Ver tabela completa</span>
        </a>
      </section>

      <app-key-indicators-section
        [additionalIndicators]="additionalKeyIndicators"
        [hiddenIndicatorCodes]="fixedKeyIndicatorCodes"></app-key-indicators-section>
    </aside>
  </div>
  <div
    *ngIf="showEconomicCalendar"
    class="dashboard-management__content dashboard-management__content--row">
    <div class="dashboard-management__content__card dashboard-management__content__card--100">
      <app-card-info>
        <div class="card-info">
          <div class="card-info__item card-info__item--100">
            <div class="card-info__item__title card-info__item__title--highlight">
              {{ tk.General.EconomicCalendar | t }}
            </div>
            <app-economic-calendar></app-economic-calendar>
          </div>
        </div>
      </app-card-info>
    </div>
    <div
      class="dashboard-management__content__card dashboard-management__content__card--25"
      style="display: none">
      <app-card-info [theme]="'purple'">
        <div class="card-info">
          <div class="card-info__item card-info__item--100">
            <div class="card-info__item__title card-info__item__title--highlight">
              {{ tk.General.AvailableCreditContracted | t }}
            </div>
            <div style="display: flex; flex-direction: column; align-items: center">
              <div style="width: 220px; height: 260px; position: relative">
                <canvas id="available-vs-contracted-credit-chart"></canvas>
              </div>
            </div>
          </div>
        </div>
      </app-card-info>
    </div>
  </div>

  <app-dialog
    #calendarEventsDialog
    [key]="'date-events'"
    [action]="'date-events'"
    [headerTheme]="'simple'"
    [breakpoints]="{
      '960px': '400px',
      '768px': '95vw',
      '640px': '100vw',
      '480px': '100vw',
    }"
    [title]="(tk.General.EventsIn | t) + ' ' + dateFormatter.formatDateInstant(this.selectedDate)">
    <p-table
      [value]="selectedDateEvents"
      [paginator]="true"
      [rows]="15"
      [showCurrentPageReport]="true"
      [paginatorDropdownAppendTo]="'body'"
      styleClass="p-datatable-sm"
      currentPageReportTemplate="Exibindo 1 a {last} de {totalRecords}"
      [rowsPerPageOptions]="[5, 10, 15, 20, 30]"
      [(first)]="tablePage">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ tk.General.Reference | t }}</th>
          <th>{{ tk.General.Company | t }}</th>
          <th>{{ tk.General.Value | t }}</th>
          <th>{{ tk.Management.NdfDueDate | t }}</th>
          <th>{{ tk.User.Type | t }}</th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-event>
        <tr>
          <!-- Se for loanOperation -->
          <ng-container *ngIf="event.loanOperation; else checkComexOperation">
            <td>{{ translateReference(event.loanOperation.reference) }}</td>
            <td>{{ event.loanOperation.companyName }}</td>
            <td>
              {{ event.loanOperation.currencyCode }}
              {{ event.loanOperation.value | vaultFormatCurrency: 2 }}
            </td>
            <td>{{ dateFormatter.formatDateInstant(selectedDate) }}</td>
            <td class="calendar-type-cell">
              Empréstimo
              <!-- Card 3201: o evento está na data em que a parcela foi paga, antes do vencimento -->
              @if (event.loanOperation.isEarlySettlement) {
                <span
                  class="calendar-early-settlement-badge"
                  [title]="
                    'Vencimento original: ' +
                    dateFormatter.formatDateInstant(event.loanOperation.dueAt, true)
                  ">
                  {{ earlySettlementBadge }}
                </span>
              }
            </td>
            <td>
              <a
                title="Ver operação"
                target="_blank"
                queryParamsHandling="merge"
                [routerLink]="[
                  '/dashboard/costs/debt/management/launch-installments',
                  event.loanOperation.id,
                ]">
                <span class="pi pi-eye color-text-brand-primary"></span>
              </a>
            </td>
          </ng-container>

          <!-- Se for comexOperation -->
          <ng-template #checkComexOperation>
            <ng-container *ngIf="event.comexOperation; else derivativeBlock">
              <td>{{ translateReference(event.comexOperation.reference) }}</td>
              <td>{{ event.comexOperation.companyName }}</td>
              <td>
                {{ event.comexOperation.currencyCode }}
                {{ event.comexOperation.lcValue | vaultFormatCurrency: 2 }}
              </td>
              <td>{{ dateFormatter.formatDateInstant(selectedDate) }}</td>
              <td>Comex</td>
              <td>
                <a
                  target="_blank"
                  [title]="tk.General.ViewOperation | t"
                  [routerLink]="['/dashboard/comex-operation/v1/edit', event.comexOperation.id]">
                  <span class="pi pi-eye color-text-brand-primary"></span>
                </a>
              </td>
            </ng-container>
          </ng-template>

          <!-- Se for derivativeOperation -->
          <ng-template #derivativeBlock>
            <td>{{ translateReference(event.derivativeOperation.demandReference) }}</td>
            <td>{{ event.derivativeOperation.companyName }}</td>
            <td>
              {{ event.derivativeOperation.currencyCode }}
              {{ event.derivativeOperation.notionalAmount | vaultFormatCurrency: 2 }}
            </td>
            <td>{{ dateFormatter.formatDateInstant(selectedDate) }}</td>
            <td>{{ event.type }}</td>
            <td>
              <a
                target="_blank"
                [title]="tk.General.ViewOperation | t"
                [routerLink]="['/dashboard/ndf-operation/list']"
                [queryParams]="{ filter: event.derivativeOperation.sequentialId }">
                <span class="pi pi-eye color-text-brand-primary"></span>
              </a>
            </td>
          </ng-template>
        </tr>
      </ng-template>
    </p-table>

    <ng-template #footer>
      <div class="dialog__footer">
        <app-button
          size="small"
          target="_blank"
          [label]="tk.General.ViewAll | t"
          [routerLink]="['/dashboard/ndf-operation/list']"
          [queryParams]="{ dueAt: dateFormatter.formatDateToYYYYMMDD(selectedDate) }">
        </app-button>
      </div>
    </ng-template>
  </app-dialog>

  <!-- Botão Flutuante de IA -->
  <app-floating-ai-button
    *ngIf="selectedCompanyId"
    [companyId]="selectedCompanyId"></app-floating-ai-button>
</section>
